import { useTranslation } from '@shared/core';
import * as Yup from 'yup';

// @todo: Add room block validation after BE structure is finalized
export const useHotelRoomBlockFormSchema = () => {
  const { tq } = useTranslation('travelMap');
  return {
    photoUrl: Yup.string().nullable(),

    isBookingLinkEnabled: Yup.boolean(),

    bookingUrl: Yup.string()
      .trim()
      .when(['isHotelRoomBlock', 'isBookingLinkDisabled'], {
        is: (isHotelRoomBlock: boolean, isBookingLinkDisabled: boolean) => isHotelRoomBlock && !isBookingLinkDisabled,
        then: (schema: Yup.StringSchema) =>
          schema
            .required(tq`Please add a hotel booking link.`)
            .typeError(tq`Please add a hotel booking link.`)
            .url(tq`Please enter a valid URL.`),
        otherwise: (schema: Yup.StringSchema) => schema.nullable(),
      }),

    checkInDate: Yup.date()
      .nullable()
      .when('isHotelRoomBlock', {
        is: true,
        then: (schema: Yup.DateSchema<Date | null>) =>
          schema.required(tq`Please add a check in date.`).test('date-range', tq`Check in date must be before check out date`, function (checkInDate) {
            const { checkOutDate } = this.parent;
            if (!checkInDate || !checkOutDate) return true;
            return checkInDate <= checkOutDate;
          }),
        otherwise: (schema: Yup.DateSchema<Date | null>) => schema.nullable(),
      }),

    checkOutDate: Yup.date()
      .nullable()
      .when('isHotelRoomBlock', {
        is: true,
        then: (schema: Yup.DateSchema<Date | null>) =>
          schema.required(tq`Please add a check out date.`).test('date-range', tq`Check out date must be after check in date`, function (checkOutDate) {
            const { checkInDate } = this.parent;
            if (!checkInDate || !checkOutDate) return true;
            return checkOutDate >= checkInDate;
          }),
        otherwise: (schema: Yup.DateSchema<Date | null>) => schema.nullable(),
      }),

    cutoffDate: Yup.date()
      .nullable()
      .when('isHotelRoomBlock', {
        is: true,
        then: (schema: Yup.DateSchema<Date | null>) => schema.required(tq`Please add cutoff date.`),
        otherwise: (schema: Yup.DateSchema<Date | null>) => schema.nullable(),
      }),

    numberOfRoomsReserved: Yup.number().when('isHotelRoomBlock', {
      is: true,
      then: (schema: Yup.NumberSchema<number | null>) =>
        schema
          .moreThan(0, tq`Please enter the number of rooms reserved.`)
          .typeError(tq`Please enter a valid number of rooms reserved.`)
          .required(tq`Please enter the number of rooms reserved.`),
      otherwise: (schema: Yup.NumberSchema<number | null>) => schema.nullable(),
    }),

    pricePerNight: Yup.number().when('isHotelRoomBlock', {
      is: true,
      then: (schema: Yup.NumberSchema<number | null>) =>
        schema
          .moreThan(0, tq`Please add price per night.`)
          .typeError(tq`Please enter the valid Joy price for the hotel.`)
          .required(tq`Please add price per night.`),
      otherwise: (schema: Yup.NumberSchema<number | null>) => schema.nullable(),
    }),

    strikeoutPricePerNight: Yup.number()
      .nullable()
      .typeError(tq`Please enter the valid Initial price for the hotel.`),
  };
};
